import { Box } from "@chakra-ui/react";
import { colors } from "../../constants/design.constants";

export const Separator = () => {
  return <Box mt="8px" mb="4px" w="40px" h="1px" bg={colors.signal} />;
};
